import {ESSENCE_SUCCESS, ESSENCE_ERROR} from '../actions/essence';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === ESSENCE_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === ESSENCE_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}